import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getLesson } from "./api";
import { DetailId, initialState, lessonResponse } from "./types";

export const lessonSlice = createSlice({
    name: 'lesson',
    initialState,
    reducers: {
        updateDetailId: (state, action: PayloadAction<DetailId>) => {
            state.updateSelectedDetailId = action.payload
        },
    },
    extraReducers: {
        [getLesson.fulfilled.toString()]: (
            state,
            action: PayloadAction<Array<lessonResponse>>
        ) => {
            state.isLoading = false
            state.getLessonResponse = action?.payload
        }
    }
})

export default lessonSlice.reducer